import ReactMarkdown, { type Components } from 'react-markdown';
import remarkGfm from 'remark-gfm';

/**
 * 동의문 본문(DB `consent_policy_versions.content` 마크다운) 한 장. 첫 로그인 `/consent`·편집기 AI 동의 창·
 * 계정 설정 「선택 동의」·지원 시작 화면이 같이 쓴다(10-03 신고 S3).
 *
 * `prose` 를 쓰지 않는다 - `@tailwindcss/typography` 가 없어 제목·표가 평문으로 납작해졌다. 꼴은 여기서 직접 준다.
 * 맨 위 `#` 제목은 그리지 않는다. 본문을 감싼 카드·창 제목이 같은 말을 이미 한다.
 */
const COMPONENTS: Components = {
  h1: () => null,
  h2: ({ children }) => <h2 className="mb-2 mt-5 text-sm font-semibold text-foreground">{children}</h2>,
  h3: ({ children }) => <h3 className="mb-1.5 mt-4 text-sm font-medium text-foreground">{children}</h3>,
  p: ({ children }) => <p className="my-2">{children}</p>,
  ul: ({ children }) => <ul className="my-2 list-disc space-y-1 pl-5 marker:text-muted-foreground">{children}</ul>,
  ol: ({ children }) => <ol className="my-2 list-decimal space-y-1 pl-5 marker:text-muted-foreground">{children}</ol>,
  li: ({ children }) => <li className="pl-0.5 [&>p]:my-0.5">{children}</li>,
  strong: ({ children }) => <strong className="font-semibold text-foreground">{children}</strong>,
  a: ({ href, children }) => (
    <a href={href} target="_blank" rel="noreferrer" className="font-medium text-primary underline-offset-4 hover:underline">
      {children}
    </a>
  ),
  table: ({ children }) => (
    <div className="my-3 overflow-x-auto rounded-md border bg-background">
      <table className="w-full border-collapse text-sm [&_tr:last-child>td]:border-b-0">{children}</table>
    </div>
  ),
  thead: ({ children }) => <thead className="bg-muted/50">{children}</thead>,
  th: ({ children }) => <th className="border-b px-3 py-2 text-left font-medium text-foreground">{children}</th>,
  td: ({ children }) => <td className="border-b px-3 py-2 align-top">{children}</td>,
  hr: () => <hr className="my-4 border-border" />,
};

export function ConsentMarkdown({ content }: { content: string }) {
  return (
    <div className="text-sm leading-relaxed text-foreground/90 [&>*:first-child]:mt-0">
      <ReactMarkdown remarkPlugins={[remarkGfm]} components={COMPONENTS}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
